const getFileSize = (size: number): string => {
    const sizeInBytes = size;
    const sizeInKB = sizeInBytes / 1024;
    const sizeInMB = sizeInKB / 1024;

    if (sizeInMB >= 1) {
        return `${sizeInMB.toFixed(2)} MB`;
    } else if (sizeInKB >= 1) {
        return `${sizeInKB.toFixed(2)} KB`;
    } else {
        return `${sizeInBytes} bytes`;
    }
};

export { getFileSize };
